// Estilos do modal de reconhecimento de alerta (marco "Reconhecimento" da
// linha do tempo do incidente).
const styles = (theme) => ({
	titulo: {
		pb: 1,
	},
	conteudo: {
		display: "flex",
		flexDirection: "column",
		gap: 1.5,
	},
	resumoAlerta: {
		display: "flex",
		flexDirection: "column",
		gap: "2px",
		p: "10px 12px",
		borderRadius: "8px",
		backgroundColor: theme.palette.action.hover,
	},
	tituloAlerta: {
		fontWeight: 600,
		fontSize: "14px",
	},
	blocoPeriodo: {
		display: "flex",
		flexDirection: "column",
		gap: 0.5,
		pl: "28px",
	},
	linhaPeriodo: {
		display: "flex",
		flexDirection: "row",
		gap: 1,
	},
	campoQuantidade: {
		width: "120px",
	},
	campoUnidade: {
		width: "130px",
	},
	acoes: {
		px: 3,
		pb: 2,
	},
});

export default styles;
